import { render } from "./UserEditForm.vue?vue&type=template&id=062c65dc&scoped=true"
import script from "./UserEditForm.vue?vue&type=script&lang=js"
export * from "./UserEditForm.vue?vue&type=script&lang=js"

import "./UserEditForm.vue?vue&type=style&index=0&id=062c65dc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062c65dc"]])

export default __exports__